import { Component, OnInit } from "@angular/core";
import { Experience } from "src/app/model/experience.dataContract";

@Component({
  selector: "app-experience",
  templateUrl: "./experience.component.html",
  styleUrls: ["./experience.component.css"],
})
export class ExperienceComponent implements OnInit {
  experienceList: Array<Experience>;

  constructor() {}

  ngOnInit(): void {
    this.experienceList = new Array<Experience>();
    this.experienceList = [
      {
        title: "Senior Software Engineer",
        company: "TechVraksh Private Limited",
        domain: "Investments",
        description: "",
        responsibilities: [
          "Developed various modules in backend as well as frontend for the SI Management.",
          "Determined coding requirements for project creation, including reports, security and service integrations.",
          "Performed unit testing, component testing and troubleshooting prior to live deployment.",
          "Ensure application security and ability to interact with multiple APIs and databases.",
          "Developed flutter mobile application for SI Management.",
        ],
        duration: "December 2020 - Present",
      },
      {
        title: "Software Engineer",
        company: "Hvantage technologies",
        domain: "Logistics",
        description: `It is web-Application for Logistics industries for their day to day
        work. It helps clients to plans, implements, and controls the
        efficient, effective, forward, and reverse flow and storage of
        goods, services, and related information between the point of origin
        and the point of consumption in order to meet customer's
        requirements.`,
        responsibilities: [
          "Developed core modules using C# 3 Layer design pattern.",
          `Developed an Angular application for the Vehicle management module
          including Angular Material and Wijmo controls.`,
          "Developed desktop edition for faster and user-friendly environment.",
          "Created complex reports using RDLC and SQL.",
          "Developed user defined functions and triggers to implement the requirements of the business.",
          "Customer support and maintenance.",
        ],
        duration: "September 2017 - November 2020",
      },
    ];
  }
}
